import { GET_DATA_MEMBER } from '../types';

export const getDataMember = (data) => ({
	type: GET_DATA_MEMBER,
	payload: data,
});
